export const handleReorder = options => (draggedValue, droppedValue) => {
  // find the options indices
  const draggedItemIdx = options.findIndex(option => option.value === draggedValue);
  const droppedItemIdx = options.findIndex(option => option.value === droppedValue);
  if (draggedItemIdx < 0 || droppedItemIdx < 0) return options;
  const newOptions = [...options];
  const valueToDisplace = newOptions[draggedItemIdx];
  const isIncreasingIndex = draggedItemIdx < droppedItemIdx;
  const stepIncrement = isIncreasingIndex ? 1 : -1;
  for (let i = draggedItemIdx; isIncreasingIndex ? i < droppedItemIdx : i > droppedItemIdx; i += stepIncrement) {
    newOptions[i] = Object.assign({}, options[i + stepIncrement], {
      displayOrder: i
    });
  }
  newOptions[droppedItemIdx] = Object.assign({}, valueToDisplace, {
    displayOrder: droppedItemIdx
  });

  // return em with new display orders
  return newOptions;
};